<template></template>

<script>
const CoreFooter = {
    name: 'CoreFooter',
    data: function() {
        return {};
    }
};
export default CoreFooter;

</script>


// WEBPACK FOOTER //
// footer.vue?50201e7a